import { init } from "../init-streaming";
import { JiraTemplateCategoryPage } from "../pages/software/jira/templates/service-management/jira-template-category-page";

init(JiraTemplateCategoryPage);
